var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.125 5.223c.72.51 2.04.738 3.375.738 1.318 0 2.637-.229 3.375-.738v.738c0 .633-1.512 1.125-3.375 1.125S.125 6.594.125 5.96zm0-1.846c.72.598 2.04.896 3.375.896 1.318 0 2.637-.298 3.375-.896v.896c0 .633-1.512 1.125-3.375 1.125S.125 4.906.125 4.273zM3.5.898c1.863 0 3.375.633 3.375 1.407 0 .79-1.512 1.406-3.375 1.406S.125 3.096.125 2.305C.125 1.53 1.637.898 3.5.898"
  })));
};
export default SvgCoins;